import makeStyles from '@mui/styles/makeStyles';

const tableButtonStyles = makeStyles((theme) => ({
    button: {
        margin: '-0.4rem 0.5rem',
    },
}));

export default tableButtonStyles;
